
import SynapticSerpent from './SynapticSerpent';

export default SynapticSerpent;
